import React, { useEffect, useRef } from 'react'
import classNames from 'classnames/bind'
import Icon from '../elementals/icon'
import Text from '../elementals/text'
import { ColorNames } from '../../constants/colorVars'
import styles from './styles.scss'

const cx = classNames.bind(styles)

export interface LiveAgentBannerProps {
  /** Callback when banner is clicked — should open SF chat */
  onClickLiveAgent: () => void
  /** Callback when banner becomes visible (for analytics) */
  onBannerDisplayed?: () => void
  elmId?: string
}

const LiveAgentBanner: React.FC<LiveAgentBannerProps> = ({
  onClickLiveAgent,
  onBannerDisplayed,
  elmId = 'ai-chat-live-agent-banner',
}) => {
  const hasFiredDisplayRef = useRef(false)

  useEffect(() => {
    if (!hasFiredDisplayRef.current) {
      hasFiredDisplayRef.current = true
      onBannerDisplayed?.()
    }
  }, [])

  return (
    <button
      className={cx('live-agent-banner')}
      onClick={onClickLiveAgent}
      data-elm-id={elmId}
      type='button'
      aria-label='Chat with a live agent'
    >
      <Icon
        name='messages'
        iconStyle='solid'
        size='big'
        color={ColorNames.Action}
        className={cx('live-agent-banner-icon')}
      />
      <Text
        className={cx('live-agent-banner-text')}
        size='tiny'
        color={ColorNames.GrayDark}
        weight='heavy'
        as='span'
      >
        Need more help? Chat with an agent
      </Text>
      <Icon
        name='arrow-up-right-from-square'
        iconStyle='regular'
        color={ColorNames.AdcDarkGreen}
        className={cx('live-agent-banner-external-icon')}
      />
    </button>
  )
}

export default LiveAgentBanner
